<div class="dp-container">

  <!-- HEADER -->
  <div class="dp-header">
    <div class="dp-header-left">
      <button class="dp-back-btn" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <div>
        <h1 class="dp-title"><i class="fa-solid fa-clock-rotate-left"></i> Delayed Projects</h1>
        <p class="dp-subtitle">
          {{ allDelayed().length }} project{{ allDelayed().length !== 1 ? 's' : '' }} flagged by OSD
          &nbsp;·&nbsp; Live
          <span class="dp-live-dot"></span>
        </p>
      </div>
    </div>

    <!-- KPI chips -->
    <div class="dp-kpi-row">
      <div class="dp-kpi-chip red">
        <span class="dp-kpi-val">{{ allDelayed().length }}</span>
        <span class="dp-kpi-lbl">Total Delayed</span>
      </div>
      <div class="dp-kpi-chip amber">
        <span class="dp-kpi-val">{{ inProgressCount() }}</span>
        <span class="dp-kpi-lbl">In Progress</span>
      </div>
      <div class="dp-kpi-chip slate">
        <span class="dp-kpi-val">{{ plannedCount() }}</span>
        <span class="dp-kpi-lbl">Planned</span>
      </div>
    </div>
  </div>

  <!-- FILTERS -->
  <div class="dp-filters">
    <div class="dp-search-wrap">
      <i class="fa-solid fa-magnifying-glass dp-search-icon"></i>
      <input
        class="dp-search"
        type="text"
        placeholder="Search by name, dept, scheme, GP, reason…"
        [value]="searchQuery()"
        (input)="onSearch($any($event.target).value)" />
      @if (searchQuery()) {
        <button class="dp-search-clear" (click)="onSearch('')">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>

    <select class="dp-select" [value]="filterDept()" (change)="onDeptFilter($any($event.target).value)">
      <option value="">All Departments</option>
      @for (d of departments(); track d) {
        <option [value]="d">{{ d }}</option>
      }
    </select>

    <span class="dp-count-badge">
      {{ filtered().length }} result{{ filtered().length !== 1 ? 's' : '' }}
    </span>
  </div>

  <!-- TABLE CARD -->
  <div class="dp-table-card">
    @if (allDelayed().length === 0) {
      <div class="dp-empty">
        <i class="fa-solid fa-circle-check"></i>
        <p>No projects marked as delayed.</p>
        <span>OSD can flag a project from the Project Detail page.</span>
      </div>
    } @else if (filtered().length === 0) {
      <div class="dp-empty">
        <i class="fa-solid fa-magnifying-glass"></i>
        <p>No results match your search.</p>
      </div>
    } @else {
      <div class="dp-table-scroll custom-scroll">
        <table class="dp-table">
          <thead>
            <tr>
              <th class="dp-th-num">#</th>
              <th class="dp-th-name sortable" (click)="setSort('name')">
                Project Name <i [class]="sortIcon('name')"></i>
              </th>
              <th class="sortable" (click)="setSort('dept')">Dept <i [class]="sortIcon('dept')"></i></th>
              <th class="sortable" (click)="setSort('scheme')">Scheme <i [class]="sortIcon('scheme')"></i></th>
              <th>GP</th>
              <th>Block</th>
              <th class="text-right sortable" (click)="setSort('cost')">Cost <i [class]="sortIcon('cost')"></i></th>
              <th class="text-right sortable" (click)="setSort('spent')">Spent <i [class]="sortIcon('spent')"></i></th>
              <th>Delay Reason</th>
              <th class="sortable" (click)="setSort('delayedBy')">Updated By <i [class]="sortIcon('delayedBy')"></i></th>
              <th class="sortable" (click)="setSort('delayedDate')">Date <i [class]="sortIcon('delayedDate')"></i></th>
              <th class="sortable" (click)="setSort('status')">Status <i [class]="sortIcon('status')"></i></th>
              <th class="text-center">View</th>
            </tr>
          </thead>
          <tbody>
            @for (p of paged(); track p.id; let i = $index) {
              <tr class="dp-row" (click)="openProject(p.id)">
                <td class="dp-td-num">{{ (currentPage() - 1) * pageSize + i + 1 }}</td>
                <td class="dp-td-name">
                  <div class="dp-name-cell">
                    <span class="dp-project-name">{{ p.name }}</span>
                    @if (p.projectId) {
                      <span class="dp-project-id">{{ p.projectId }}</span>
                    }
                  </div>
                </td>
                <td><span class="dp-dept-badge">{{ p.dept || '—' }}</span></td>
                <td class="dp-scheme">{{ p.scheme || '—' }}</td>
                <td>{{ $any(p).gp || '—' }}</td>
                <td>{{ $any(p).block || p.loc || '—' }}</td>
                <td class="text-right dp-cost">{{ formatCost(p.cost) }}</td>
                <td class="text-right dp-cost">{{ formatCost(p.spent) }}</td>
                <td class="dp-reason">
                  @if ($any(p).isDelayed && $any(p).delayedReason) {
                    <span class="dp-osd-tag">OSD</span> {{ $any(p).delayedReason }}
                  } @else if ($any(p).isDelayed) {
                    <span class="dp-osd-tag">OSD</span> Flagged by OSD
                  } @else if (p.status === 'Stuck') {
                    <span class="dp-stuck-tag">Stuck</span> Project is stuck
                  } @else {
                    <span class="dp-auto-tag">Overdue</span> &gt;60 days past target
                  }
                </td>
                <td class="dp-by">{{ $any(p).delayedBy || '—' }}</td>
                <td class="dp-date">{{ formatDate($any(p).delayedDate || $any(p).updatedAt) }}</td>
                <td>
                  <span class="dp-status-pill"
                    [class.dp-status--inprogress]="p.status === 'In Progress'"
                    [class.dp-status--stuck]="p.status === 'Stuck'"
                    [class.dp-status--planned]="p.status === 'Planned'"
                    [class.dp-status--completed]="p.status === 'Completed'">
                    {{ p.status }}
                  </span>
                </td>
                <td class="text-center">
                  <button class="dp-view-btn" (click)="openProject(p.id); $event.stopPropagation()">
                    <i class="fa-solid fa-eye"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- PAGINATION -->
      @if (totalPages() > 1) {
        <div class="dp-pagination">
          <span class="dp-page-info">
            Page {{ currentPage() }} of {{ totalPages() }}
            &nbsp;·&nbsp; {{ filtered().length }} records
          </span>
          <div class="dp-page-btns">
            <button class="dp-page-btn" [disabled]="currentPage() === 1" (click)="prevPage()">
              <i class="fa-solid fa-chevron-left"></i> Prev
            </button>
            <button class="dp-page-btn" [disabled]="currentPage() === totalPages()" (click)="nextPage()">
              Next <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      }
    }
  </div>

</div>
